import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';

const SelfCareAbroadExistingPackagesSkeleton = () => {
  return (
    <div className='abroad-customer-existing-packages-skeleton'>
      <div className='title-skeleton'>
        <Skeleton />
      </div>
      <div className='existing-package-skeleton-wrapper'>
        <div className='package-title-toggleBtn-wrapper'>
          <div className='package-title-skeleton'>
          <Skeleton />
          </div>
          <div className='toggleBtn-skeleton'>
          <Skeleton circle height={30} width={30}/>
          </div>
        </div>
        <div className='package-details-skeleton'>
          <Skeleton />
        </div>
        <div className='package-start-date-skeleton'>
        <Skeleton />
        </div>
      </div>
      <div className='more-packages-button-skeleton'>
      < Skeleton width={200} height={40} />
      </div>
    </div>
  );
};

export default SelfCareAbroadExistingPackagesSkeleton;
